<!--
 * @Author: xiehangyi
 * @LastEditors: xiehangyi
 * @Description: 状态
-->
<template>
  <div
    :class="{
      'lc-status': true,
      'lc-status--point': withPoint
    }"
    :style="customStyles"
  >
    {{ reLabel }}
  </div>
</template>
<script>
import { getDictItem } from '@/apis/application/dict.js';
import { mapGetters } from 'vuex';
export default {
  name: 'LcStatus',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    label:{
      type: String,
      default: '标签'
    },
    withPoint: {
      type: Boolean,
      default: false
    },
    optionsDict: {
      type: [String, Number],
      default: ''
    },
    dictConfigList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      reDictConfigList: []
    };
  },
  computed: {
    ...mapGetters({
      appId: 'appId',
    }),
    getDictConfig() {
      return this.reDictConfigList.find(e => e.value === this.value)
    },
    reLabel() {
      return this.getDictConfig?.label || this.label
    },
    customStyles() {
      if (this.getDictConfig) {
        return {
          '--color': this.getDictConfig.color,
        }
      }
      return {}
    }
  },
  created() {
    this.loadOptions()
  },
  methods: {
    async loadOptions() {
      if (this.optionsDict) {
        const res = await getDictItem(this.appId, {
          dictCode: this.optionsDict,
          pageIndex: 1,
          pageSize: 999
        })
        this.reDictConfigList = res.data ? res.data.map(item => {
          const label = item.itemLabel
          const value = item.itemValue
          const tagDictConfig = this.dictConfigList.find(t => t.value === item.itemValue)
          return {
            label,
            value,
            color: tagDictConfig?.color || ''
          }
        }) : []
      } else {
        this.reDictConfigList = this.dictConfigList || []
      }
    }
  },
};
</script>
